import { css, Global, GlobalProps } from '@emotion/react';
import theme from '@styles/theme';
import { BASE_PATH } from '@config/index';
const GlobalStyles = (props: GlobalProps) => <Global
// eslint-disable-next-line react/jsx-props-no-spreading
{...props} styles={css`
      @font-face {
        font-family: 'Uniform EC Condensed Light';
        src: url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.eot);
        src:
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.eot?#iefix)
            format('embedded-opentype'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff) format('woff'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.ttf) format('truetype');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'vox-font-label';
        src: url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.eot);
        src:
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.eot?#iefix)
            format('embedded-opentype'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff) format('woff'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.ttf) format('truetype');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'vox-font-regular';
        src: url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.eot);
        src:
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.eot?#iefix)
            format('embedded-opentype'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff) format('woff'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.ttf) format('truetype');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'Uniform EC Condensed';
        src: url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.eot);
        src:
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.eot?#iefix)
            format('embedded-opentype'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.woff) format('woff'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_regular/uniformprocon-reg-webfont.ttf) format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }

      @font-face {
        font-family: 'Uniform EC Condensed Medium';
        src: url(${BASE_PATH}/fonts/uniform_pro_condensed_medium/uniformprocon-med-webfont.eot);
        src:
          url(${BASE_PATH}/fonts/uniform_pro_condensed_medium/uniformprocon-med-webfont.eot?#iefix)
            format('embedded-opentype'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_medium/uniformprocon-med-webfont.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_medium/uniformprocon-med-webfont.woff) format('woff'),
          url(${BASE_PATH}/fonts/uniform_pro_condensed_medium/uniformprocon-med-webfont.ttf) format('truetype');
        font-weight: 500;
        font-style: normal;
        font-display: swap;
      }

      @font-face {
        font-family: 'Uniform EC Extra Condensed';
        src: url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.eot);
        src:
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.eot?#iefix)
            format('embedded-opentype'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.woff) format('woff'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.ttf) format('truetype');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
      }

      @font-face {
        font-family: 'vox-font';
        src: url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.eot);
        src:
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.eot?#iefix)
            format('embedded-opentype'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.woff) format('woff'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.ttf) format('truetype');
        font-weight: 300;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'Uniform EC Extra Condensed';
        src: url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.eot);
        src:
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.eot?#iefix)
            format('embedded-opentype'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.woff) format('woff'),
          url(${BASE_PATH}/fonts/uniform_pro_extra_condensed_medium/uniformproxcon-med-webfont.ttf) format('truetype');
        font-weight: normal;
        font-style: normal;
        font-display: swap;
      }
      @font-face {
        font-family: 'Noe Display';
        src: url(${BASE_PATH}/fonts/noe_display_bold/NoeDisplay-Bold.eot);
        src:
          url(${BASE_PATH}/fonts/noe_display_bold/NoeDisplay-Bold.eot?#iefix) format('embedded-opentype'),
          url(${BASE_PATH}/fonts/noe_display_bold/NoeDisplay-Bold.woff2) format('woff2'),
          url(${BASE_PATH}/fonts/noe_display_bold/NoeDisplay-Bold.woff) format('woff');
        font-display: swap;
        font-weight: 700;
      }
      @font-face {
        font-family: 'vox-ds-icons';
        src: url(${BASE_PATH}/fonts/vox-ds-icons/vox-ds-icons.eot);
        src:
          url(${BASE_PATH}/fonts/vox-ds-icons/vox-ds-icons.eot?#iefix) format('embedded-opentype'),
          url(${BASE_PATH}/fonts/vox-ds-icons/vox-ds-icons.ttf) format('truetype'),
          url(${BASE_PATH}/fonts/vox-ds-icons/vox-ds-icons.woff) format('woff'),
          url(${BASE_PATH}/fonts/vox-ds-icons/vox-ds-icons.svg) format('svg');
        font-weight: normal;
        font-style: normal;
        font-display: block;
      }

      [class^='icon-'],
      [class*=' icon-'] {
        /* use !important to prevent issues with browser extensions that change fonts */
        font-family: 'icomoon' !important;
        speak: never;
        font-style: normal;
        font-weight: normal;
        font-variant: normal;
        text-transform: none;
        line-height: 1;

        /* Better Font Rendering =========== */
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
      }

      .icon-chevron_right:before {
        content: '\\e90c';
      }

      ::selection {
        background: #3297fd;
        color: #ffffff;
      }

      ::-moz-selection {
        background: #3297fd;
        color: #ffffff;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type='number'] {
        -moz-appearance: textfield;
        appearance: textfield;
      }

      ::-moz-selection {
        text-shadow: none;
      }

      ::selection {
        text-shadow: none;
      }

      a {
        text-decoration: none;
      }
      html,
      body,
      div,
      span,
      applet,
      object,
      iframe,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p,
      blockquote,
      pre,
      a,
      abbr,
      acronym,
      address,
      big,
      cite,
      code,
      del,
      dfn,
      em,
      img,
      ins,
      kbd,
      q,
      s,
      samp,
      small,
      strike,
      strong,
      sub,
      sup,
      tt,
      var,
      b,
      u,
      i,
      center,
      dl,
      dt,
      dd,
      ol,
      ul,
      li,
      fieldset,
      form,
      label,
      legend,
      table,
      caption,
      tbody,
      tfoot,
      thead,
      tr,
      th,
      td,
      article,
      aside,
      canvas,
      details,
      embed,
      figure,
      figcaption,
      footer,
      header,
      hgroup,
      menu,
      nav,
      output,
      ruby,
      section,
      summary,
      time,
      mark,
      audio,
      video {
        margin: 0;
        padding: 0;
        border: 0;
        vertical-align: baseline;
        box-sizing: border-box;
      }
      /* Global focus styles for accessibility - WCAG 2.4.7 Focus Visible */
      /* Show outline only when navigating with keyboard (focus-visible) */
      input:focus-visible,
      button:focus-visible,
      select:focus-visible,
      textarea:focus-visible,
      a:focus-visible,
      [tabindex]:focus-visible,
      [role='button']:focus-visible,
      [role='link']:focus-visible,
      [role='menuitem']:focus-visible,
      [role='tab']:focus-visible {
        outline: 2px solid ${theme.rawColors.blue500};
        outline-offset: 2px;
        /* Ensure outline is not clipped by parent containers */
        position: relative;
        z-index: 1;
      }
      /* Hide outline when clicking with mouse (focus but not focus-visible) */
      input:focus:not(:focus-visible),
      button:focus:not(:focus-visible),
      select:focus:not(:focus-visible),
      textarea:focus:not(:focus-visible),
      a:focus:not(:focus-visible),
      [tabindex]:focus:not(:focus-visible),
      [role='button']:focus:not(:focus-visible),
      [role='link']:focus:not(:focus-visible),
      [role='menuitem']:focus:not(:focus-visible),
      [role='tab']:focus:not(:focus-visible) {
        outline: none;
      }
      /* Hide outline for other elements that might receive focus */
      :focus:not(input):not(button):not(select):not(textarea):not(a):not([tabindex]):not([role='button']):not(
          [role='link']
        ):not([role='menuitem']):not([role='tab']):not(:focus-visible) {
        outline: 0;
      }
      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }
      strong,
      b {
        font-weight: 600;
      }
      i,
      em {
        font-style: italic;
      }
      sup {
        vertical-align: super;
        font-size: smaller;
      }
      sub {
        vertical-align: sub;
        font-size: smaller;
      }
      article,
      aside,
      details,
      figcaption,
      figure,
      footer,
      header,
      hgroup,
      menu,
      nav,
      section {
        display: block;
      }
      body {
        line-height: 1;
      }
      ol,
      ul {
        list-style: disc;
        text-align: left;
        list-style-position: inside;
      }
      ol {
        list-style-type: decimal;
        a {
          text-decoration: underline;
        }
      }
      blockquote,
      q {
        quotes: none;
      }
      blockquote:before,
      blockquote:after,
      q:before,
      q:after {
        content: '';
        content: none;
      }
      table {
        border-collapse: collapse;
        border-spacing: 0;
      }
      input[type='search']::-webkit-search-cancel-button,
      input[type='search']::-webkit-search-decoration,
      input[type='search']::-webkit-search-results-button,
      input[type='search']::-webkit-search-results-decoration {
        -webkit-appearance: none;
        -moz-appearance: none;
      }
      input[type='search'] {
        -webkit-appearance: none;
        -moz-appearance: none;
        -webkit-box-sizing: content-box;
        -moz-box-sizing: content-box;
        box-sizing: content-box;
      }
      textarea {
        overflow: auto;
        vertical-align: top;
        resize: vertical;
      }
      audio,
      canvas,
      video {
        display: inline-block;
        *display: inline;
        *zoom: 1;
        max-width: 100%;
      }
      audio:not([controls]) {
        display: none;
        height: 0;
      }
      [hidden] {
        display: none;
      }

      a:active,
      a:hover {
        outline: 0;
      }
      /* Link focus styles are handled in the global focus-visible styles above */
      img {
        max-width: 100%;
        border: 0;
        /* 1 */
        -ms-interpolation-mode: bicubic;
        /* 2 */
      }
      figure {
        margin: 0;
      }
      form {
        margin: 0;
      }
      fieldset {
        border: 1px solid #c0c0c0;
        margin: 0 2px;
        padding: 0.35em 0.625em 0.75em;
      }
      legend {
        border: 0;
        padding: 0;
        white-space: normal;
        *margin-left: -7px;
      }
      button,
      input,
      select,
      textarea {
        padding: 0;
        font-size: 100%;
        /* 1 */
        font-family: inherit;
        margin: 0;
        /* 2 */
        vertical-align: baseline;
        /* 3 */
        *vertical-align: middle;
        /* 3 */
      }
      button,
      input {
        line-height: normal;
      }
      button,
      select {
        text-transform: none;
      }
      button,
      html input[type='button'],
      input[type='reset'],
      input[type='submit'] {
        -webkit-appearance: button;
        cursor: pointer;
        *overflow: visible;
      }
      button[disabled],
      html input[disabled] {
        cursor: default;
      }
      input[type='checkbox'],
      input[type='radio'] {
        box-sizing: border-box;
        padding: 0;
        *height: 13px;
        *width: 13px;
      }
      input[type='search'] {
        -webkit-appearance: textfield;
        -moz-box-sizing: content-box;
        -webkit-box-sizing: content-box;
        box-sizing: content-box;
      }
      input[type='search']::-webkit-search-cancel-button,
      input[type='search']::-webkit-search-decoration {
        -webkit-appearance: none;
      }
      button::-moz-focus-inner,
      input::-moz-focus-inner {
        border: 0;
        padding: 0;
      }
      textarea {
        overflow: auto;
        vertical-align: top;
      }
      table {
        border-collapse: collapse;
        border-spacing: 0;
      }
      button,
      input,
      select,
      textarea {
        color: #222;
      }
      ::-moz-selection {
        background: #b3d4fc;
        text-shadow: none;
      }
      ::selection {
        background: #b3d4fc;
        text-shadow: none;
      }
      img {
        vertical-align: middle;
      }
      fieldset {
        border: 0;
        margin: 0;
        padding: 0;
      }
      textarea {
        resize: vertical;
      }
      .chromeframe {
        margin: 0.2em 0;
        background: #ccc;
        color: #000;
        padding: 0.2em 0;
      }
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      input[type='number'] {
        -moz-appearance: textfield;
      }

      html {
        font-size: 100%;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        &.hidden__scroll {
          scrollbar-color: transparent transparent;
          overflow: hidden;
          &::-webkit-scrollbar {
            z-index: -1;
          }
        }
      }

      body {
        min-height: 100vh;
        overflow-x: hidden;
        color: ${theme.rawColors.darkGrey700};
        font-family: ${theme.fonts.uniform};
        font-style: normal;
        font-weight: normal;
        line-height: 140%;
        font-size: ${theme.fontSizes.text}px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;

        &.--no-overflow,
        &.modal-open {
          overflow: hidden;
        }
        @media screen and (max-width: 1024px) {
          &.modal-aside-mobile {
            overflow: hidden;
          }
        }

        #modal-root {
          position: fixed;
          z-index: 9999;
          top: 0;
          bottom: 0;
          height: auto;
        }

        .display__one {
          font-family: 'Uniform EC Condensed';
          font-style: normal;
          font-weight: 300;
          font-size: 72px;
          line-height: 100%;
        }
        .display__two {
          font-family: 'Noe Display';
          font-style: normal;
          font-weight: bold;
          font-size: 64px;
          line-height: 110%;
          letter-spacing: 0.03em;
        }
        .display__three {
          font-family: 'Uniform EC Extra Condensed';
          font-style: normal;
          font-weight: normal;
          font-size: 46px;
          line-height: 100%;
          letter-spacing: 0.06em;
          text-transform: uppercase;
        }

        h1 {
          font-family: 'Uniform EC Extra Condensed';
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 110%;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          @media (max-width: ${theme.breakpoints[3]}) {
            & {
              font-size: 32px;
              line-height: 110%;
            }
          }
        }

        h2 {
          font-family: 'Uniform EC Extra Condensed';
          font-style: normal;
          font-weight: normal;
          font-size: 40px;
          line-height: 110%;
          letter-spacing: 2px;
          text-transform: none;
          &.bold {
            font-weight: 500;
          }
          @media (max-width: ${theme.breakpoints[2]}) {
            & {
              font-size: ${theme.fontSizes.h2}px;
              letter-spacing: 1.6px;
            }
          }
        }

        h3 {
          font-family: 'Uniform EC Extra Condensed';
          font-style: normal;
          font-weight: ${theme.fontWeights.normal};
          font-size: ${theme.fontSizes.h2}px;
          line-height: 100%;
          letter-spacing: 1.6px;
          text-transform: none;
          &.bold {
            font-weight: 500;
          }
          @media (max-width: ${theme.breakpoints[2]}) {
            & {
              font-size: ${theme.fontSizes.h3}px;
              letter-spacing: 1.2px;
            }
          }
        }

        h4 {
          font-family: 'Uniform EC Condensed Medium';
          font-style: normal;
          font-weight: 500;
          font-size: 24px;
          line-height: 100%;
          letter-spacing: 0.05em;
          text-transform: none;
          &.bold {
            font-weight: 500;
          }
          @media (max-width: ${theme.breakpoints[3]}) {
            & {
              font-size: 20px;
            }
          }
        }

        h5 {
          font-family: 'Uniform EC Condensed';
          font-style: normal;
          font-weight: 400;
          font-size: ${theme.fontSizes.h4}px;
          line-height: 140%;
          letter-spacing: 1px;
          text-transform: none;
        }

        h6 {
          font-family: 'Uniform EC Condensed Medium';
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 140%;
          letter-spacing: 0.1em;
        }

        h7 {
          font-family: 'Uniform EC Condensed Medium';
          font-style: normal;
          font-weight: 500;
          font-size: 13px;
          line-height: 140%;
          letter-spacing: 0.1em;
        }

        p.price {
          font-family: 'Uniform EC Extra Condensed';
          font-style: normal;
          font-weight: normal;
          font-size: 24px;
          line-height: 100%;
          letter-spacing: 0.05em;
          text-transform: uppercase;
          &.big {
            font-size: 32px;
          }
          &.small {
            font-size: 18px;
          }
        }

        p {
          font-family: 'Uniform EC Condensed';
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 140%;
          a,
          a:visited {
            color: ${theme.rawColors.darkGrey700};
            text-decoration: underline;
          }
          &.bold {
            font-family: 'Uniform EC Condensed Medium';
            font-weight: 500;
          }
          &.big {
            font-size: 18px;
          }
          &.small {
            font-size: 14px;
          }
          &.caption {
            font-size: 12px;
          }
          &.subtitle {
            letter-spacing: 0.05em;
          }
          &.subtitle-special {
            letter-spacing: 0.08em;
          }
          &.scription {
            letter-spacing: 0.01em;
          }
          &.description {
            letter-spacing: 0.01em;
            line-height: 175%;
          }
          &.omnibus {
            color: ${theme.rawColors.omnibus};
            font-size: ${theme.fontSizes.omnibus}px;
          }
          @media (max-width: ${theme.breakpoints[3]}) {
            & {
              font-size: 14px;
            }
          }
        }
        h2.global_display-two.mobile {
          font-family: ${theme.fonts.noe};
          font-size: ${theme.fontSizes.mediumHeading}px;
          font-weight: ${theme.fontWeights.bold};
          line-height: 110%;
          letter-spacing: 1.92px;
          @media (max-width: ${theme.breakpoints[2]}) {
            & {
              font-size: ${theme.fontSizes.smallerHeading}px;
              letter-spacing: 1.56px;
            }
          }
          @media (max-width: ${theme.breakpoints[0]}) {
            & {
              font-size: ${theme.fontSizes.displayMobileSmall}px;
              letter-spacing: 1.2px;
            }
          }
        }
        h2.global_display-two {
          font-family: ${theme.fonts.noe};
          font-size: ${theme.fontSizes.mediumHeading}px;
          font-weight: ${theme.fontWeights.bold};
          line-height: 110%;
          letter-spacing: 1.92px;
          @media (max-width: ${theme.breakpoints[2]}) {
            & {
              font-size: ${theme.fontSizes.smallerHeading}px;
              letter-spacing: 1.56px;
            }
          }
          @media (max-width: ${theme.breakpoints[0]}) {
            & {
              font-size: ${theme.fontSizes.displayMobileSmall}px;
              letter-spacing: 1.2px;
            }
          }
        }
        h3.global_display-three {
          font-family: ${theme.fonts.uniformExtra};
          font-size: ${theme.fontSizes.smallHeading}px;
          font-weight: ${theme.fontWeights.normal};
          line-height: 100%;
          letter-spacing: 3px;
          @media (max-width: ${theme.breakpoints[2]}) {
            & {
              font-size: ${theme.fontSizes.smallerHeading}px;
              letter-spacing: 2.6px;
            }
          }
          @media (max-width: ${theme.breakpoints[0]}) {
            & {
              font-size: ${theme.fontSizes.displayMobileSmall}px;
              letter-spacing: 2px;
            }
          }
        }
        h3.global_display-two-small {
          font-family: ${theme.fonts.noe};
          font-size: ${theme.fontSizes.h1}px;
          font-weight: ${theme.fontWeights.bold};
          line-height: 110%;
          letter-spacing: 1.2px;
        }
        h4.global_heading_four {
          font-family: ${theme.fonts.uniform};
          font-size: ${theme.fontSizes.h3}px;
          font-weight: ${theme.fontWeights.normal};
          line-height: 140%;
          letter-spacing: 1.2px;
          @media (max-width: ${theme.breakpoints[2]}) {
            & {
              font-size: ${theme.fontSizes.h4}px;
              letter-spacing: 1px;
            }
          }
        }
        p.global_text {
          font-family: ${theme.fonts.uniform};
          font-size: ${theme.fontSizes.text}px;
          font-weight: ${theme.fontWeights.normal};
          line-height: 140%;
          letter-spacing: ${theme.letterSpacings.smallCaps};
          a {
            color: ${theme.rawColors.darkGrey700};
            text-decoration: underline;
          }
            @media (max-width: ${theme.breakpoints[2]}) {
            & {
              font-size: ${theme.fontSizes.smallText}px;
            }
          }
        }
          p.global_new_text {
          font-family: ${theme.fonts.uniform};
          font-size: ${theme.fontSizes.bigText}px;
          font-weight: ${theme.fontWeights.normal};
          line-height: 140%;
          letter-spacing: ${theme.letterSpacings.newText};
          a {
            color: ${theme.rawColors.darkGrey700};
            text-decoration: underline;
          }
          @media (max-width: ${theme.breakpoints[2]}) {
            & {
              font-size: ${theme.fontSizes.text}px;
            }
          }
        }
        label {
          font-family: 'Uniform EC Condensed';
          font-style: normal;
          font-weight: normal;
          font-size: 16px;
          line-height: 140%;
          letter-spacing: 0.1em;
        }
        a {
          transition: color ${theme.transitions.atomTransition};
          color: #373737;
          &:hover,
          &:visited {
            color: ${theme.rawColors.neutralBlack};
          }
          &.small {
            font-size: 14px;
          }
          &.link {
            font-family: 'Uniform EC Condensed';
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 140%;
            letter-spacing: 0.05em;
            text-decoration-line: underline;
            color: #373737;

            &.big {
              font-size: 18px;
            }
            &.small {
              font-size: 14px;
            }
            &.caption {
              font-size: 12px;
            }
            &.subtitle {
              letter-spacing: 0.05em;
            }
          }
        }

        // NOTE: fix swiper fade effect click bug
        .swiper-fade {
          .swiper-slide-prev,
          .swiper-slide-next {
            z-index: -1;
          }
        }
      }
      .pac-container {
        box-shadow: unset;
        border: 1px solid #e1e1e1;
      }
      .pac-item {
        padding-left: 12px;
      }
      .pac-icon {
        display: 'none';
        width: 0;
        height: 0;
      }
      .pac-container:after {
        background-image: none !important;
        width: 0;
        height: 0px;
      }
      .menu-element-active span:last-child:before {
        content: '';
        position: absolute;
        width: 100%;
        opacity: 1 !important;
        bottom: -4px;
        height: 1px;
        background: #373737;
      }
      .pac-container {
        z-index: 9999 !important;
      }
      #custommerce-rc {
        width: 100% !important;
        height: auto;
        overflow-x: hidden;
      }
      #custommerce-rc .cm-video {
        width: 100% !important;
      }

      .visually-hidden,
      .screen-reader-only {
        position: absolute !important;
        width: 1px !important;
        height: 1px !important;
        padding: 0 !important;
        margin: -1px !important;
        overflow: hidden !important;
        clip: rect(0, 0, 0, 0) !important;
        white-space: nowrap !important;
        border: 0 !important;
      }

      /* Footer navigation links - ensure focus outline is visible - WCAG 2.4.7 Focus Visible */
      .footer_nav:focus-visible {
        outline: 2px solid ${theme.rawColors.blue500} !important;
        outline-offset: 2px !important;
        background-color: transparent !important;
        background: none !important;
      }
      .footer_nav:focus:not(:focus-visible) {
        outline: none;
        background-color: transparent;
        background: none;
      }

      /* ProductCard - show outline on inner container instead of Link - WCAG 2.4.7 Focus Visible */
      a[data-testid='ListingProductCard']:focus-visible {
        outline: none !important;
      }
      a[data-testid='ListingProductCard']:focus-visible > div:first-of-type {
        outline: 2px solid ${theme.rawColors.blue500} !important;
        outline-offset: 2px !important;
        border-radius: 2px;
        position: relative;
        z-index: 1;
      }
      ol, ul {
        line-height: 140%;
      }
    `} />;
export default GlobalStyles;